<template>
    <div class="prescribe-overlay">
        <!-- 开药方 -->
        <van-overlay class-name="prescribe-overlay-wapper" :show="overlayShow" @click="overlayShow = false">
            <div class="prescribe-overlay" @click.stop>
                <div class="prescribe-overlay-top">
                    <span class="prescribe-overlay-top-title"> 线上开药</span>
                    <van-icon name="cross" @click="overlayShow = false" />
                </div>
                <div class="prescribe-overlay-content">
                    <div class="prescribe-overlay-content-title">
                        服务介绍
                    </div>
                    <div class="prescribe-overlay-content-introduce">
                        <span>1. 血液及肿瘤正品新特药、常用药，寄到家</span>
                        <span>2. 数百位血液肿瘤权威医生在线接诊，可开处方</span>
                    </div>
                </div>
                <div class="prescribe-overlay-content">
                    <div class="prescribe-overlay-content-title matter">
                        注意事项
                    </div>
                    <div class="prescribe-overlay-content-introduce">
                        <span>1. 需要上传清晰门诊/住院病历、小结等就诊凭证</span>
                        <span>2. 交流前请准备好具体的疾病问题和药品名称</span>
                        <span>3. 有问题随时联系专属客服</span>
                    </div>
                </div>

                <div class="prescribe-overlay-user-instructions">
                    <van-checkbox v-model="checked" checked-color="#0FB7AD" icon-size="16px">
                        <div class="prescribe-overlay-user-instructions-text">
                            请阅读并同意 <a href="/#/xy">《用户协议》</a>及<a href="/#/ys">《隐私政策》</a>
                        </div>
                    </van-checkbox>
                </div>

                <div class="prescribe-overlay-operation">
                    <van-button @click="onClick" type="primary" color="#03cbbf" block round>确定</van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import {LocationHref} from '@/util/common'

export default {
    props: {
      pageType: {
        type: Number,
        default: 1
      }
    },
    data() {
        return {
            overlayShow: false,
            checked: false
        }
    },
    methods: {
        onClick() {
            if (!this.checked) {
                this.$toast({ message: '请先阅读并同意《用户协议》及《个人隐私协', className: 'toast-overlay' })
                return
            }
            Interface.mFootPrint(1, 83,0, 3, 0, 0,0,'跳转线上开药服务说明，点击已读并同意的按钮')
            // 跳转链接
            LocationHref('https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=online_ky&t='+localStorage.getItem('user_id')+'&u='+Math.random()*5)
        }
    },
    watch: {
      checked(newVal, oldVal) {
        if (newVal) {
          Interface.mFootPrint(1, 83,0, this.pageType, 0, 0,0,'医疗服务-线上开药-用户协议勾选')
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.prescribe-overlay-wapper {
    z-index: 99999999;
    .prescribe-overlay {
        position: absolute;
        bottom: 0px;
        background: #fff;
        width: 100%;
        border-radius: 12px 12px 0 0;

        &-top {
            box-sizing: border-box;
            background: url('/static/bytx/ylfw/medical_head_popup_2@3x.png') no-repeat;
            background-size: 100% 100%;
            background-position: 100% 100%;
            height: 100px;
            width: 100%;
            margin-top: -30px;
            padding-top: 40px;
            text-align: center;
            position: relative;
            .van-icon {
                position: absolute;
                right: 15px;
                top: 40px;
                font-size: 18px;
                width: 30px;
                height: 30px;
            }

            &-title {
                margin-top: 10px;
                display: inline-block;
                font-size: 18px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #282828;
            }
        }

        &-content {
            margin: 0px 20px;
            &-title {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #282828;
            }

            &-introduce {
                padding-top: 14px;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #777777;

                span {
                    padding-bottom: 10px;
                }
            }

            .matter {
                margin-top: 10px;
            }
        }

        &-user-instructions {
            margin: 0px 20px;
            margin-top: 14px;
            margin-bottom: 16px;

            &-text {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #777777;
                display: flex;
                align-items: center;
            }

            a {
                color: #0cc4b9ff;
            }
        }

        &-operation {
            margin: 0px 20px auto;

            .van-button {
                width: 335px;
                height: 42px;
                border-radius: 22px;
                margin-bottom: 36px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/overlay/prescribe.vue